import type {
  ApiEnvironment,
  ApiUser,
} from 'api/userEnvironment/types/ApiUserEnvironment';
import type { UserDashboardApiApplicantProfile } from 'modules/userDashboard/api/applicantProfile/types/UserDashboardApiApplicantProfile';
import type { UserDashboardApiEmptyApplicantProfile } from 'modules/userDashboard/api/applicantProfile/types/UserDashboardApiEmptyApplicantProfile';
import { isNonAdmin } from 'utils/userEnvironment';

export function hasResumeDb(
  user: ApiUser | null,
  environment: ApiEnvironment | null,
): boolean {
  if (!environment || !user) return false;
  if (CURRENT_LOCALE() !== 'en') return false;

  return environment.isUS || Boolean(user.isRecruitable);
}

export function hasWorkHistoryJobs(
  profile:
    | UserDashboardApiApplicantProfile
    | UserDashboardApiEmptyApplicantProfile,
): boolean {
  if (!profile) return false;

  return profile.workHistoryJobs.length > 0;
}

export function promoteResumeDatabase(
  user: ApiUser | null,
  environment: ApiEnvironment,
) {
  if (!hasResumeDb(user, environment)) return false;

  if (user) {
    if (!isNonAdmin(user)) return false;

    if (user.isRecruitable === false) return false;
    if (user.isRecruitable && user.resumeId) return false;
  }

  return true;
}
